export const getScheduleState = state => state.schedules;
export const getScheduleDataState = state => state.schedules.scheduleData;
export const getScheduleDataMasterAgreementState = state =>
  state.schedules.scheduleData.masterAgreement;
